export default {
  Table_Common: {
    TuoDong: 'Drag',
    ZhuanJieMa_MingCheng: 'Name',
    ZhuanJie_Ma: 'Code',
    TingYon_ZhuanTai: 'Inactive Status',
    ChuangJian_ShiJian: 'Create time',
    DengLu_ShiJian: 'Login Time',
    YongHu: 'User',
    DengLu: 'Login',
    DengChu: 'Logout',
    PiLiang_TiChu: 'Batch Logout',
    ChengGong: 'Success',
    ShiBai: 'Fail',
    CuoWu_Ma: 'Error Code',
    DengLu_IP: 'Login IP',
    JiaZai_Zhong: 'Loading',
    ShouJi_HaoMa: 'Phone',
    DianHua: 'Phone',
    XingBie: 'Sex',
    ZhiGong_LeiBie: 'Category',
    ZhenJin: 'Fee',
    Yuan: '',
    JueSe: 'Role',
    ShuJu_QuanXian: 'Data Permissions',
    QuanXian_FanWei: 'Permission Scope',
    ShiYong_ZhenSuo: 'Applicable Clinics',
    YuanGong_ZhuangTai: 'Status',
    QiYong: 'Enable',
    TingYong: 'Unable',
    TingYong_BiaoShi: ' (Disabled)',
    ShiFou_CanYu_PaiBan: 'Scheduling',
    ShiFou_PaiBan: 'Scheduling',
    Shi: 'Yes',
    Fou: 'No',
    PaiBan: "Scheduling's",
    YouXiang: 'Email',
    ChuSheng_RiQi: 'DOB',
    CaoZuo: 'Operation',
    Nan: 'Male',
    Nv: 'Female',
    MiaoShu: 'Description',
    CaiDan_MingCheng: 'Menu name',
    LuYou: 'Router',
    GongNeng_QuanXian: 'Authority',
    YaoFei: 'Prescription',
    ZhenJiu_JinE: 'Acupuncture',
    TaoPiao: 'Ticket',
    YouFei: 'Postage',
    ZhenJin_JinE: 'Fee',
    TuiNa_ZhengGu: 'Massage/Boning',
    BaGuan_JinE: 'Cupping',
    YouHuiQuan_MingCheng: 'Coupon name',
    QiYong_ZhuangTai: 'Enable',
    MianE: 'Denomination',
    ManJian_MuBiao_JinE: 'Full deduction',
    ShiYong_QingKuang: 'Usage situation',
    Yi_ShiYong: 'Used',
    Yi_Shou: 'Sold',
    ShiFou_YiShou: 'Sold or not',
    Yi_FaFang: 'Issued',
    ShiYong_DanJu: 'Scope of use',
    GuoQi_ShiJian: 'Expiration time',
    ShiYong_GuoQi_ShiJian: 'Usage expiration time',
    YouXiaoQi: 'Validity',
    ChangQiYouXiao: 'Long-term valid',
    FaFangQi_ShiChang: '{duration}{unit} from issuance',
    GouMaiQi_ShiChang: '{duration}{unit} from purchase',
    Zhi_RiQi: 'Until {date}',
    ShouMai_ShiJian: 'Sale time',
    ShouMai_JieShu: 'End {date}',
    GuoQi_RiQi: 'Expiration date',
    HuanZhe_XingMing: 'Patient name',
    LaiYuan: 'Source',
    YiShi_Duan: 'Medic',
    GuanLi_Duan: 'Management',
    JianDang_ShiJian: 'Create time',
    ShouHuo_Ren: 'Consignee',
    YiDong_SheZhi: 'Mobile settings',
    MoRen_DiZhi: 'Default',
    SheWei_MoRen: 'Set def',
    ChanPin_MingCheng_En: 'Product Name(EN)',
    YaoPin_MingCheng_En: 'Name(En)',
    BianMa: 'Code',
    GuiGe_En: 'Sku(EN)',
    NongSuo: 'Ratio',
    JingZhong: 'Weight',
    DanWei_ChengBen_Jia: 'Unit cost price',
    DanWei_ShouJia: 'Unit selling price',
    KuCun: 'Inventory',
    ChuFang_DanWei: 'Prescription unit',
    YaoPin_ZhuangTai: 'Enable',
    GuiGe_ZhuangTai: 'SKU Status',
    ChengFen_Yao: 'Component drug',
    DingDan_ZhuangTai: 'Order status',
    DingDan_JinE: 'Order amount',
    XiaDan_Ren: 'Create staff name',
    ShenPi_Ren: 'Examine staff name',
    GengXin_ShiJian: 'Update time',
    ShenPi_ShiJian: 'Examine time',
    ChengBen_Jia: 'Cost price',
    XiaDan_ShuLiang: 'Order quantity',
    QianShou_ShuLiang: 'Receive quantity',
    Yi_QianShou: 'Signed',
    BenCi_QianShou: 'This signing',
    QianShou_ShiJian: 'Signing time',
    ShenPi_Zhong: 'Examine',
    Dai_QianShou: 'Ordered',
    Yi_WanCheng: 'Complete',
    BoHui: 'Reject',
    Yi_ZuoFei: 'Cancel',
    DiaoZheng_RenYuan: 'Create staff name',
    ShenHe_RenYuan: 'Examine staff name',
    DiaoZheng_Qian_KuCun: 'Inventory before',
    DiaoZheng: 'Difference',
    DiaoZheng_Hou_KuCun: 'Inventory new',
    XiangMu_MingCheng: 'Name',
    ZhongLei: 'Types',
    JiFei: 'Method',
    HanLiang: 'Content',
    ChongZhi_JinE: 'Recharge',
    ZengSong_JinE: 'Gift',
    ShiFou_ShouChong: 'Is First',
    YuE: 'Balance',
    GuiGe: 'Sku',
    JingMai: 'Meridian',
    XueWei: 'Acupoint',
    FangFa: 'Method',
    WeiZhi: 'Position',
    DanWei: 'Unit',
    XiangMu: 'Project',
    ZiTou: 'Prefix',
    RiQi_GeShi: 'Date Format',
    BuLing: 'Digit',
    QiShi: 'Number',
    LeiXing: 'Type',
    ShuLiang: 'Quantity',
    KeHu_BianHao: 'Customer No.',
    JiuZhen: 'Appointment',
    HeJi: 'Sum',
    XueWei_GeShu: 'Acupoint',
    DanJu_LeiXing: 'Record type',
    ShiYong_CiShu: 'Number of uses',
    YouHui_JinE_XianZhi: 'Limit discount',
    ZhongYi_ChuFang: 'CM prescription',
    ZhongYi_ChuFang_Zhen: 'CM prescription(Acup)',
    ZhongYi_ChuFang_Tui: 'CM prescription(Mas)',
    ZhongYi_ChuFang_Ba: 'CM prescription(Cup)',
    BingLi_BaoGao: 'Diagnosis Record',
    BingJia_ZhengMingShu: 'Sick Leave Certificate',
    DaoZhen_ZhengMingShu: 'Attendance Record',
    HuaiYun_ZhengMingShu: 'Pregnancy Certificate',
    ShouJu: 'Receipt',
    ZhuanJie_Xin: 'Referral Letter',
    DaYin_ShiJian: 'Time',
    DaYin_Ren: 'Name',
    DaYin_ZhenSuo: 'Clinic',
    GuanLiYuan: 'Administrator',
    Biaozhun: 'Standard',
    GuiGe_BianMa: 'Sku Code',
    PinYin: 'Pin Yin',
    YaoPing_GuiGe: 'Specification',
    NongDu: 'Ratio',
    ShiFou_NongSuo: 'Is Ratio',
    TiaoMa: 'Barcode',
    PiCiHao: 'Batch',
    HuiYuan_MiaoShu: 'Description',
    HuiYuan_MiaoShu_En: 'Description（En）',
    GuiShu_ZhenSuo: 'Clinic Affiliation',
    CaiDan: 'Menu',
    XinZeng_LuYou: 'Add',
    XiuGai_LuYou: 'Edit',
    MoRen_DanWei_ChengBenjia: 'Unit cost price',
    MoRen_DanWei_ShouJia: 'Unit price',
    DingDan_YaoPing_ShuLiang: 'Quantity',
    XiangMu_ShuLiang: 'Item count',
    DingGou_Zong_ShuLiang: 'Total order quantity',
    YaoFang: 'Name',
    ShiFou_GongKai: 'Is Public',
    ChuangJian_Ren: 'Create Staff',
    YingXiao_LeiXing: 'Marketing Type',
    DingJia_FangShi: 'Pricing',
    HuoDong_JiaGe: 'Price',
    HuoDong_ZheKou: 'Discount',
    HuoDong_ShangPin: 'Promotional Goods',
    Xiang_JinE: 'Current',
    BianDong_JinE: 'Change',
    ErWeiMa: 'QrCode',
    FaFang_CiShu: 'Number of issued',
    YaoPin_PiHao: 'Batch Number',
    CaiGou: 'Purchase',
    PanDian: 'Stocktaking',
    BianDong_Qian_KuCun: 'Inventory before',
    BianDong_Zhi: 'Change',
    BianDong_Hou_KuCun: 'Inventory after',
    LaiYuan_DanJuHao: 'Source No',
    CaoZuo_RenYuan: 'Operator',
    CaoZuo_ShiJian: 'Operation time',
    HuanZhe_BianHao: 'Patient Code',
    YuYue_ShiJian: 'Appointment Time',
    TuiJian_YuanYin: 'Recommendation',
  },
}
